var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "nativewind/jsx-runtime";
import axios from 'axios';
import React from 'react';
import { ScrollView, View } from 'react-native';
import styled from 'styled-components/native';
import { match } from 'ts-pattern';
import { SccButton } from '@/components/atoms/SccButton';
import UserBirthYearForm from '@/components/form/UserBirthYearForm';
import UserEmailForm from '@/components/form/UserEmailForm';
import UserMobilityToolsForm from '@/components/form/UserMobilityToolsForm';
import UserNicknameForm from '@/components/form/UserNicknameForm';
import { color } from '@/constant/color';
import { font } from '@/constant/font';
import { useMe } from '@/atoms/Auth';
import useNavigation from '@/navigation/useNavigation';
import { useUpdateUser } from '@/screens/SignupScreen/hooks/useUpdateUser';
import ToastUtils from '@/utils/ToastUtils';
import { ScreenLayout } from '@/components/ScreenLayout';
export default function ProfileEditorDetailScreen({ route, }) {
    var _a, _b, _c, _d, _e, _f;
    const { field } = route.params;
    const { userInfo, syncUserInfo } = useMe();
    const navigation = useNavigation();
    const { formState, formValue, updateField, submit } = useUpdateUser({
        initialValues: {
            nickname: (_a = userInfo === null || userInfo === void 0 ? void 0 : userInfo.nickname) !== null && _a !== void 0 ? _a : '',
            email: (_b = userInfo === null || userInfo === void 0 ? void 0 : userInfo.email) !== null && _b !== void 0 ? _b : '',
            birthYear: (_d = (_c = userInfo === null || userInfo === void 0 ? void 0 : userInfo.birthYear) === null || _c === void 0 ? void 0 : _c.toString()) !== null && _d !== void 0 ? _d : '',
            phoneNumber: '',
            isPhoneVerified: false,
            mobilityTools: (_e = userInfo === null || userInfo === void 0 ? void 0 : userInfo.mobilityTools) !== null && _e !== void 0 ? _e : [],
            isNewsLetterSubscriptionAgreed: (_f = userInfo === null || userInfo === void 0 ? void 0 : userInfo.isNewsLetterSubscriptionAgreed) !== null && _f !== void 0 ? _f : false,
        },
    });
    const onSubmit = () => __awaiter(this, void 0, void 0, function* () {
        var _a;
        try {
            yield submit();
            yield syncUserInfo();
            ToastUtils.show('변경되었습니다.');
            navigation.goBack();
        }
        catch (error) {
            let msg = '오류가 발생했습니다.';
            if (axios.isAxiosError(error)) {
                const data = (_a = error.response) === null || _a === void 0 ? void 0 : _a.data;
                if (data === null || data === void 0 ? void 0 : data.msg) {
                    msg = data.msg;
                }
            }
            ToastUtils.show(msg);
        }
    });
    const title = match(field)
        .with('nickname', () => '닉네임을 입력해주세요')
        .with('email', () => '이메일을 입력해주세요')
        .with('birthYear', () => '태어난 해를 알려주세요')
        .with('mobilityTools', () => '나의 이동 상황에 해당하는 유형을 모두 알려주세요')
        .exhaustive();
    const renderForm = () => {
        switch (field) {
            case 'nickname':
                return (_jsx(UserNicknameForm, { value: formValue.nickname, state: formState.nickname, onChangeText: value => updateField('nickname', value), isClearable: true }));
            case 'email':
                return (_jsx(UserEmailForm, { value: {
                        email: formValue.email,
                        isNewsLetterSubscriptionAgreed: formValue.isNewsLetterSubscriptionAgreed,
                    }, state: {
                        email: formState.email,
                        isNewsLetterSubscriptionAgreed: formState.isNewsLetterSubscriptionAgreed,
                    }, onChangeText: value => updateField('email', value), onChangeNewsLetterSubscriptionAgreed: value => updateField('isNewsLetterSubscriptionAgreed', value), isClearable: true }));
            case 'birthYear':
                return (_jsx(UserBirthYearForm, { value: formValue.birthYear, state: formState.birthYear, onChangeText: value => updateField('birthYear', value) }));
            case 'mobilityTools':
                return (_jsx(UserMobilityToolsForm, { value: formValue.mobilityTools, onChangeValue: value => updateField('mobilityTools', value), onSubmit: onSubmit }));
        }
    };
    const isValid = match(field)
        .with('nickname', () => formState.nickname === 'VALID')
        .with('email', () => (formState.email === 'VALID' &&
        formState.isNewsLetterSubscriptionAgreed === 'VALID') ||
        (formState.email === 'VALID' &&
            formState.isNewsLetterSubscriptionAgreed === undefined) ||
        (formState.email === undefined &&
            formState.isNewsLetterSubscriptionAgreed === 'VALID'))
        .with('birthYear', () => formState.birthYear === 'VALID')
        .with('mobilityTools', () => formState.mobilityTools === 'VALID')
        .exhaustive();
    return (_jsxs(ScreenLayout, { isHeaderVisible: true, safeAreaEdges: ['bottom'], children: [_jsxs(Title, { children: [title, title === 'mobilityTools' ? _jsx(Details, { children: "(\uC911\uBCF5\uC120\uD0DD \uAC00\uB2A5)" }) : null] }), _jsx(ScrollView, { style: { marginTop: 32 }, children: renderForm() }), _jsx(View, { style: {
                    width: '100%',
                    backgroundColor: color.white,
                    padding: 20,
                }, children: _jsx(SccButton, { onPress: onSubmit, buttonColor: "blue50", borderColor: "blue50", textColor: "white", fontFamily: font.pretendardBold, text: "\uD655\uC778", isDisabled: !isValid, elementName: "profile_editor_confirm" }) })] }));
}
const Details = styled.Text `
  font-family: ${font.pretendardRegular};
  font-size: 16px;
  color: ${color.gray50};
`;
const Title = styled.Text `
  padding-left: 20px;
  padding-right: 20px;
  margin-top: 32px;
  font-family: ${font.pretendardBold};
  font-size: 24px;
  color: ${color.gray100};
`;
